import { Assignment, AssignmentDetails } from "../types/Assignment";
import { deleteData, getData, postData } from "./apiService";

export const getAllAssignmentsByEventId = async (event_id: string, is_music: boolean): Promise<AssignmentDetails[]> => {
  try {
    const response = await getData(`/events/${event_id}/assignments/?is_music=${is_music}`, {});
    return response.data as AssignmentDetails[];
  } catch (error) {
    console.error('Failed to fetch event:', error);
    return [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
  }
};

export const getAllAssignmentsByEventIdandInstrument = async (event_id: string, instrument_id: string): Promise<AssignmentDetails[]> => {
  try {
    const response = await getData(`/events/${event_id}/assignments/${instrument_id}`, {});  // The API call is unchanged
    return response.data as AssignmentDetails[];
  } catch (error) {
    console.error('Failed to fetch event:', error);
    return [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
  }
};

export const postAssignments = async (assignments: Assignment[]): Promise<boolean> => {
  try {
    const response = await postData(`/assignments`, { assignments });  // The API call is unchanged
    // Assuming the API returns an array of events in response.data
    return response.success;
  } catch (error) {
    console.error('Failed to fetch event:', error);
    return false;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
  }
};

export const removeAssignment = async (registrant_id: string): Promise<boolean> => {
  try {
    const response = await deleteData(`/assignments/${registrant_id}`, {});  // The API call is unchanged
    return response.success;
  } catch (error) {
    console.error('Failed to remove assignment:', error);
    return false;
  }
};